<template>
	<el-aside class="leftbox">
		<h2><i class="el-icon-s-custom" style="margin-right: 8px"></i>{{ cinfo.isMain === 0 && cinfo.isBuy === 0 ? '账户中心':'企业中心'   }}</h2>
		<div class="menubox">
			<ul class="menu-wrap">
				<li v-for="(menu, i) in filteredMenus" :key="menu.id" :class="{ 'is-open': menu.active }" @click.stop="handleClickMenus(menu, i, $event)">
					<dl>
						<dt v-if="cinfo.isMain==1 || (cinfo.isMain === 0 && cinfo.isBuy == 1)">
							<a @click.stop="handleRouter(menu, i)">
								<span>{{ menu.title }}</span>
								<i class="arrow" v-if="menu.childs" @click.stop="handleClickIcon(menu, i)"></i>
							</a>
						</dt>
						<template v-if="menu.childs">
							<dd v-for="smenu in menu.childs" :key="'ms_' + smenu.id">
								<a :class="$route.path === smenu.path ? 'is-sel' : ''" @click.stop="handleRouter(smenu, i)">
									{{ smenu.title }}
								</a>
							</dd>
						</template>
					</dl>
				</li>
			</ul>
			<div class="logout" @click="onLogout">退出登录</div>
		</div>
	</el-aside>
</template>

<script>
	import userMenus from '@/data/userMenu';
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				menus: userMenus
			};
		},
		computed: {
			...mapGetters('User', ['cinfo']),

			// 根据账号权限过滤企业中心菜单
			filteredMenus() {
				const isMain = this.cinfo?.isMain === 1;
				const level = this.cinfo?.corporateLevel;
				let result;

				if (isMain) {
					result = this.menus;
				} else {
					const isBuy = this.cinfo?.isBuy === 1;
					if (isBuy) {
						result = this.menus
							.map(menu => {
								if (menu.id === 1) {
									// const allowed = ['1-2'];
									const allowed = ['1-2', '1-6', '1-7'];
									return {
										...menu,
										childs: menu.childs?.filter(c => allowed.includes(String(c.id))) || []
									};
								} else if (menu.id === 2) {
									return menu;
								}
								return menu;
							})
							.filter(menu => menu.childs && menu.childs.length > 0);
					} else {
						result = this.menus
							.map(menu => {
								if (menu.id === 1) {
									const allowedNoBuy = ['1-2'];
									return {
										...menu,
										childs: menu.childs?.filter(c => allowedNoBuy.includes(String(c.id))) || []
									};
								}
								if (menu.id === 2) {
									return null;
								}
								return menu;
							})
							.filter(menu => menu && menu.childs && menu.childs.length > 0);
					}
				}

				// corporateLevel == 0 时不显示 1-3
				if (level === 0) {
					result = result.map(menu => {
						if (menu.id === 1) {
							return {
								...menu,
								childs: menu.childs?.filter(c => String(c.id) !== '1-3') || []
							};
						}
						return menu;
					});
				}

				return result;
			},
		},
		watch: {
			'$route.path': {
				handler() {
					this.setMenuStateByRoute();
				},
				immediate: true
			}
		},
		mounted() {
			this.setMenuStateByRoute();
		},
		methods: {
			onLogout() {
				this.$confirm('确定要退出登录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.$store.dispatch('User/logout').then(() => {});
					})
					.catch(() => {});
			},

			setMenuStateByRoute() {
				const currentPath = this.$route.path;
				this.menus.forEach((menu, index) => {
					if (menu.childs) {
						const shouldOpen = menu.childs.some(child => currentPath === child.path || currentPath === menu.path);
						this.$set(this.menus, index, { ...menu, active: shouldOpen });
					} else {
						this.$set(this.menus, index, { ...menu, active: currentPath === menu.path });
					}
				});
			},

			handleClickMenus(menu, i, event) {
				const target = event.target;
				if (target.closest('dd') || target.closest('.is-sel')) {
					return;
				}
				if (menu.active) {
					this.menus[i].active = true;
				} else {
					this.menus.forEach((item, index) => {
						item.active = index === i;
					});
				}
			},

			handleClickIcon(menu, i) {
				if (menu.active) {
					this.menus[i].active = !this.menus[i].active;
				} else {
					this.menus.forEach((item, index) => {
						item.active = index === i;
					});
				}
			},

			handleRouter(menu, i) {
				if (menu.childs) {
					if (menu.active) {
						this.menus[i].active = !this.menus[i].active;
					} else {
						this.menus.forEach((item, index) => {
							item.active = index === i;
						});
					}
				} else {
					this.$router.push(menu.path);
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.leftbox {
		position: relative;
		width: 260px !important;
		background-color: #fff;
		border-radius: 12px;
		border: 1px solid #e2e8f0;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: hidden;

		.logout {
			height: 40px;
			margin: 14px;
			display: block;
			cursor: pointer;
			padding-left: 22px;
			border-radius: 8px;
			color: rgb(239, 68, 68);
			text-decoration: none;
			line-height: 40px;
			font-size: 15px;
			font-weight: 500;
			transition: all 0.15s;
			border-top: 1px solid rgb(229, 229, 229);
		}

		.logout:hover {
			background: #fef0f0;
		}

		.arrow {
			position: relative;
			display: inline-block;
			left: auto;
			top: auto;
		}
		.arrow:after {
			position: absolute;
			right: 0;
			top: -3px;
			display: block;
			content: '';
			width: 7px;
			height: 7px;
			border-top: 1px solid #94a3b8;
			border-right: 1px solid #94a3b8;
			transition: 0.3s;
			transform: rotate(45deg);
		}
		.arrow-down:after {
			transform: rotate(135deg);
		}
		h2 {
			height: 64px;
			margin: 0;
			padding-left: 24px;
			line-height: 64px;
			font-size: 18px;
			font-weight: 700;
			color: #0f172a;
			font-weight: 700;
			border-bottom: 1px dashed #e2e8f0;
		}
		.menubox {
			padding: 8px 0 20px;
			background-color: #fff;
			ul {
				position: relative;
				z-index: 10;
				margin: 0;
				padding: 0;
			}
			li {
				line-height: 44px;
				color: #334155;
				list-style-type: none;
				font-size: 14px;
			}
			dl {
				margin: 0;
			}
			dt {
				height: 44px;
				padding: 0 16px;
				font-size: 15px;
				font-weight: 500;
				color: #334155;
				span {
					position: relative;
					padding-left: 16px;
				}
				span:before {
					position: absolute;
					top: 50%;
					left: 0px;
					transform: translate(0, -50%);
					content: '';
					width: 6px;
					height: 6px;
					background: #94a3b8;
					border-radius: 50%;
				}
				a {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding-left: 0;
					height: 100%;
					cursor: pointer;
				}
			}
			dd {
				height: 40px;
				margin: 2px 0;
				padding: 0 16px;
				display: none;
				a {
					display: block;
					cursor: pointer;
					padding-left: 20px;
					color: #64748b;
					text-decoration: none;
					font-size: 14px;
					border-radius: 8px;
					line-height: 40px;
					transition: all 0.15s;
				}
			}
			dt:hover {
				background-color: #f8fafc;
			}
			.is-open {
				dt {
					color: #155dfc;
					background-color: #eff6ff;
					span:before {
						background: #155dfc;
					}
				}
				dd {
					display: block;
				}
				.arrow:after {
					border-top: 1px solid #155dfc;
					border-right: 1px solid #155dfc;
					transform: rotate(135deg);
				}
			}
			a {
				color: #334155;
				text-decoration: none;
				cursor: pointer;
			}
			a:hover {
				color: #155dfc;
				background-color: #f8fafc;
			}
			a.is-sel {
				background-color: #eff6ff;
				border-radius: 8px;
				color: #155dfc;
				font-weight: 500;
			}
		}
	}
	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.leftbox {
			width: 26% !important;
		}
	}
</style>
